var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,28V4c0-0.5517578,0.4482422-1,1-1h18c0.5517578,0,1,0.4482422,1,1v14h2V4c0-1.6542969-1.3457031-3-3-3H7 C5.3457031,1,4,2.3457031,4,4v24c0,1.6542969,1.3457031,3,3,3h13v-2H7C6.4482422,29,6,28.5517578,6,28z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 18,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9482422,24.6835938c-0.1191406-0.359375-0.4316406-0.6201172-0.8066406-0.6738281l-2.9433594-0.4199219 l-1.2792969-2.9833984C26.7617188,20.2382812,26.4003906,20,26,20s-0.7617188,0.2382812-0.9189453,0.6064453l-1.2792969,2.9833984 l-2.9433594,0.4199219c-0.375,0.0537109-0.6875,0.3144531-0.8066406,0.6738281 c-0.1201172,0.359375-0.0263672,0.7558594,0.2412109,1.0234375l2.1464844,2.1464844l-0.4296875,3.0048828 c-0.0556641,0.390625,0.1230469,0.7773438,0.4570312,0.9873047c0.3339844,0.2128906,0.7597656,0.2060547,1.0878906-0.0136719 L26,30.2021484l2.4453125,1.6298828C28.6132812,31.9443359,28.8066406,32,29,32 c0.1845703,0,0.3701172-0.0507812,0.5332031-0.1542969c0.3339844-0.2099609,0.5126953-0.5966797,0.4570312-0.9873047 l-0.4296875-3.0048828l2.1464844-2.1464844C31.9746094,25.4394531,32.0683594,25.0429688,31.9482422,24.6835938z  M27.7929688,26.7929688c-0.2226562,0.2226562-0.3271484,0.5371094-0.2832031,0.8486328l0.1835938,1.2861328l-1.1386719-0.7597656 C26.3867188,28.0556641,26.1933594,28,26,28s-0.3867188,0.0556641-0.5546875,0.1679688l-1.1386719,0.7597656l0.1835938-1.2861328 c0.0439453-0.3115234-0.0605469-0.6259766-0.2832031-0.8486328l-1.0859375-1.0859375l1.5205078-0.2167969 c0.3457031-0.0498047,0.6396484-0.2753906,0.7773438-0.5966797L26,23.5390625l0.5810547,1.3544922 c0.1376953,0.3212891,0.4316406,0.546875,0.7773438,0.5966797l1.5205078,0.2167969L27.7929688,26.7929688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractSmall);
export default __webpack_public_path__ + "static/media/contract--small.3e8d45e5d0b5a2ebe32cf4385ea06cde.svg";
export { ForwardRef as ReactComponent };